import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { selectProductOldTotalPrice, selectProductTotalPriceByPaymentMethod } from '@telialt/utils/src/eshopSelectors';
import { formatCurrencyWithoutZeroDecimals } from '@telialt/utils/src/helpers';

import { PriceCurrency, PriceOldPrice } from './TopPrice.styles';

type ProductTotalAndOldPriceProps = {
    hasMonthlyPrice?: boolean;
};

export const ProductTotalAndOldPrice: FC<ProductTotalAndOldPriceProps> = ({ hasMonthlyPrice }) => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();

    const currentPrice = selectProductTotalPriceByPaymentMethod(cart);
    const oldPrice = selectProductOldTotalPrice(cart);

    const a11yTotalPrice = `${formatCurrencyWithoutZeroDecimals(currentPrice.value)} ${currentPrice.currency}`;
    const a11yOldPrice = oldPrice ? `${formatCurrencyWithoutZeroDecimals(oldPrice.value)} ${oldPrice.currency}` : '';

    return (
        <div>
            <span aria-label={`${t['eshop.product_page.top_price.total']} ${a11yTotalPrice}`}>
                <span aria-hidden="true">
                    {hasMonthlyPrice && `${t['eshop.product_page.top_price.total']} `}
                    {currentPrice && (
                        <>
                            <strong>{formatCurrencyWithoutZeroDecimals(currentPrice.value)}&nbsp;</strong>
                            <PriceCurrency>{currentPrice.currency}</PriceCurrency>
                        </>
                    )}
                </span>
            </span>
            {oldPrice && (
                <PriceOldPrice aria-label={`${t['eshop.product_page.old_price_accessible']} ${a11yOldPrice}`}>
                    <span aria-hidden="true">
                        {formatCurrencyWithoutZeroDecimals(oldPrice.value)}&nbsp;{oldPrice.currency}
                    </span>
                </PriceOldPrice>
            )}
        </div>
    );
};
